import CustomQuerySetupWizardSheetStepCommonComponent from 'webapp/components/custom-query/setup/wizard/sheet/step-common';

export default class CustomQuerySetupWizardSheetStepMetricComponent extends CustomQuerySetupWizardSheetStepCommonComponent {
	override stepTitle = 'Select a metric value';
	override stepDescription =
		'Select a value column that includes the metric value you’d like to track. In other words, choose the column that you want your first metric to measure. Want to measure more than this metric? Select one for now—you will be able to create additional metrics later.';

	override get isNextDisabled(): boolean {
		return this.hasErrors || !this.selectedColumnId;
	}
}
